import { NgModule } from '@angular/core';
import { TrendPipe } from '../pipe/trend.pipe';
import { SearchPipe } from '../pipe/search.pipe';
import { NicetxtPipe } from '../pipe/nicetxt.pipe';
import { OrderByTypePipe } from '../pipe/orderbytype.pipe';
import { SanitizeHtmlPipe } from '../pipe/sanitize-html.pipe';
import { ThousandSuffixesPipe } from '../pipe/thousand.pipe';
import { NegativePipe } from '../pipe/negative.pipe';

/**
 * Shared custom pipes that are needed by lazy-loaded feature modules (which
 * cannot see AppModule's declarations). AppModule imports this so the existing
 * app-wide users keep working unchanged. Grow this as future lazy modules need
 * more shared pipes.
 */
@NgModule({
  declarations: [
    TrendPipe,
    SearchPipe,
    NicetxtPipe,
    OrderByTypePipe,
    SanitizeHtmlPipe,
    ThousandSuffixesPipe,
    NegativePipe,
  ],
  exports: [
    TrendPipe,
    SearchPipe,
    NicetxtPipe,
    OrderByTypePipe,
    SanitizeHtmlPipe,
    ThousandSuffixesPipe,
    NegativePipe,
  ],
})
export class SharedPipesModule {}
